<template>
   <div>
        <div class="table-wrapper on-767" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%'></div>
                    <div data-width='30%' class="bold white center">KD ’000</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font skyBlue">Current investments at fair value through profit or loss</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Funds -mandatorily at FVTPL </div>
                    <div data-width='15%' class="font light-gray">3,623</div>
                    <div data-width='15%' class="font">4,738</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Other funds</div>
                    <div data-width='15%' class="font light-gray">6,162</div>
                    <div data-width='15%' class="font">3,802</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white ">9,785</div>
                    <div data-width='15%' class=" bold white">8,540</div>
                </div>
                <div class="trow">
                    <div data-width='70%' class="font skyBlue">Non-current investments at fair value through other comprehensive income</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Quoted equities- designated at inception</div>
                    <div data-width='15%' class="font light-gray">1,676</div>
                    <div data-width='15%' class="font">1,240</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Funds</div>
                    <div data-width='15%' class="font light-gray">1,897</div>
                    <div data-width='15%' class="font">2,092</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Unquoted equities - designated at inception</div>
                    <div data-width='15%' class="font light-gray">1,752</div>
                    <div data-width='15%' class="font">3,028</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class=" bold white "> 5,325</div>
                    <div data-width='15%' class=" bold white">6,360</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%'></div>
                    <div data-width='30%' class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font skyBlue">استثمارات متداولة بالقيمة العادلة من خلال بيان الربح أو الخسارة:</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">صناديق - مصنفة بشكل إلزامي بالقيمة العادلة من خلال بيان الربح أو الخسارة</div>
                    <div data-width='15%' class="font light-gray">3,623</div>
                    <div data-width='15%' class="font">4,738</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">صناديق أخرى</div>
                    <div data-width='15%' class="font light-gray">6,162</div>
                    <div data-width='15%' class="font">3,802</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white ">9,785</div>
                    <div data-width='15%' class=" bold white">8,540</div>
                </div>
                <div class="trow">
                    <div data-width='70%' class="font skyBlue"> استثمارات غير متداولة بالقيمة العادلة من خلال بيان الربح أو الخسارة:</div>
                    <div data-width='15%' class="light-gray"></div>
                    <div data-width='15%'></div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">أسهم مسعرة – مصنفة منذ النشأة</div>
                    <div data-width='15%' class="font light-gray">1,676</div>
                    <div data-width='15%' class="font">1,240</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">صناديق</div>
                    <div data-width='15%' class="font light-gray">1,897</div>
                    <div data-width='15%' class="font">2,092</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">أسهم غير مسعرة – مصنفة منذ النشأة</div>
                    <div data-width='15%' class="font light-gray">1,752</div>
                    <div data-width='15%' class="font">3,028</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class=" bold white "> 5,325</div>
                    <div data-width='15%' class=" bold white">6,360</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>